import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import { withRouter } from 'react-router-dom';

import routeTo from '../../../router/utils/routeTo';
import layout from '../../../app/layout';
import { media } from '../../../utils/style';

import { HeaderLogo_company } from './__generated__/HeaderLogo_company.graphql';

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: ${layout.spacing};
  height: ${layout.header.height};

  ${media.medium`
    justify-content: flex-end;
    padding: 0 20px;
  `};

  ${media.large`
    justify-content: flex-end;
    padding: 0 20px;
  `};

  ${media.extraLarge`
    justify-content: flex-end;
    padding: 0 20px;
  `};
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 45px;
`;

const Logo = styled.span`
  color: #607389;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
`;

export type Props = {
  company: HeaderLogo_company;
  logoRoute: string;
  wrapperStyle?: Record<string, unknown>;
};

const HeaderLogo = ({ history, company, logoRoute, wrapperStyle }: Props) => {
  const goToHome = (path) => {
    history.push(routeTo(path));
  };

  const { logo, nameFriendly } = company;

  return (
    <Wrapper>
      <Logo style={wrapperStyle} onClick={() => goToHome(logoRoute)}>
        {logo ? (
          <Image src={company?.logo?.url} title={company?.nameFriendly} />
        ) : (
          <p>{nameFriendly}</p>
        )}
      </Logo>
    </Wrapper>
  );
};

export default withRouter(
  createFragmentContainer(HeaderLogo, {
    company: graphql`
      fragment HeaderLogo_company on Company {
        nameFriendly
        logo {
          url(fitIn: true)
        }
      }
    `,
  }),
);
